import { configureStore } from "@reduxjs/toolkit";
import SideBarSlice from "./slices/sideBarSlice";
import ModeSliceSlice from "./slices/modeSlice";

export const store = configureStore({
  reducer: {
    sideBar: SideBarSlice,
    mode: ModeSliceSlice,
  },
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
